'use client';

import { createContext } from 'react';

import type { DropdownFloatingContextInterface } from '../types/use-dropdown.types';

export const DropdownFloatingContext = createContext({} as DropdownFloatingContextInterface);

DropdownFloatingContext.displayName = 'Dropdown.Floating.Context';
